// ** Icons Import
import { Home, Circle, Menu } from "react-feather";

export default [
  {
    id: "home",
    title: "Home",
    icon: <Menu size={20} />,
    badge: "light-primary",
  },
  {
    id: "dashboards",
    title: "Dashboards",
    icon: <Home size={20} />,
    badge: "light-primary",
    badgeText: "4",
    children: [
      {
        id: "mainView",
        title: "Main view",
        icon: <Circle size={12} />,
        navLink: "/dashboard",
      },
      {
        id: "origination",
        title: "Origination",
        icon: <Circle size={12} />,
        navLink: "/origination",
      },
      {
        id: "servicing",
        title: "Servicing",
        icon: <Circle size={12} />,
        navLink: "/servicing",
      },
      {
        id: "capitalMarkets",
        title: "Capital Markets",
        icon: <Circle size={12} />,
        navLink: "/capital-markets",
      },
    ],
  },
];
